/**
 * @file automatically generated from MApp.Endpoints.ManagementController
 */ 

import { MetadataClient } from '../metadataClient';
import { IValidationResult, ISaveTenant, ITenantListItem, IUsageOverview, IUsage, ISessions, ITenantUsageFilter, ITenantUsage, ILogMessage, ISaveConnection, IGuidObject, IConnection, IConnectionListItem, IValidateConnection, IChargeListItem, IAvailableLocalization, ISaveAvailableLocalization, IBranding } from '../models';

export class ManagementClient extends MetadataClient {

    public static saveTenant(tenant: ISaveTenant) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/tenants`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(tenant)
			})
        );
    }

    public static deleteTenant(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/tenants/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getTenants() {
        return MetadataClient.ajax<ITenantListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/tenants`)
        );
    }

    public static getUsageOverview() {
        return MetadataClient.ajax<IUsageOverview>(
            new Request(MetadataClient.endpointsUrl + `api/v2/management/usageoverview`)
        );
    }

    public static getUsage() {
        return MetadataClient.ajax<IUsage[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/usage`)
        );
    }

    public static getSessions() {
        return MetadataClient.ajax<ISessions>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/usage/sessions`)
        );
    }

    public static tenantUsage(filter: ITenantUsageFilter) {
        return MetadataClient.ajax<ITenantUsage[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/management/usage/tenants`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(filter)
			})
        );
    }

    public static downloadTenantUsage(tenants: string, fromDate: string, toDate: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v2/management/usage/tenants/download?tenants=${encodeURIComponent(tenants)}&fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`)
        );
    }

    public static isValidTenant(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/tenants/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static getLogs() {
        return MetadataClient.ajax<ILogMessage[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/logs`)
        );
    }

    public static getLogStackTrace(id: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/logs/${encodeURIComponent(id)}/stacktrace`)
        );
    }

    public static deleteLogs() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/logs/all`, {
				method: 'DELETE'
			})
        );
    }

    public static deleteLog(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/logs/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static downloadLogs() {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/logs/all`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST'
			})
        );
    }

    public static downloadLog(ids: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/logs`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(ids)
			})
        );
    }

    public static saveConnection(connection: ISaveConnection) {
        return MetadataClient.ajax<IGuidObject>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/connections`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(connection)
			})
        );
    }

    public static updateConnection(id: string, connection: ISaveConnection) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/connections/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(connection)
			})
        );
    }

    public static getConnection(id: string) {
        return MetadataClient.ajax<IConnection>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/connections/${encodeURIComponent(id)}`)
        );
    }

    public static getConnections() {
        return MetadataClient.ajax<IConnectionListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/connections`)
        );
    }

    public static deleteConnection(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/connections/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static isValidConnection(connection: IValidateConnection) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/connections/isvalid`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(connection)
			})
        );
    }

    public static getCharges() {
        return MetadataClient.ajax<IChargeListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/charges`)
        );
    }

    public static getDomains() {
        return MetadataClient.ajax<string[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/management/domains`)
        );
    }

    public static getLocalizations() {
        return MetadataClient.ajax<IAvailableLocalization[]>(
            new Request(MetadataClient.endpointsUrl + `api/v3/management/localizations`)
        );
    }

    public static saveLocalizations(saveLocalization: ISaveAvailableLocalization) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/management/localizations`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(saveLocalization)
			})
        );
    }

    public static deleteLocalization(languageCode: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v3/management/localizations?languageCode=${encodeURIComponent(languageCode)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getMasterBranding() {
        return MetadataClient.ajax<IBranding>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/branding`)
        );
    }

    public static deleteMasterBranding() {
        return MetadataClient.ajax<IBranding>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/branding`, {
				method: 'DELETE'
			})
        );
    }

    public static updateMasterBranding(branding: IBranding) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/branding`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(branding)
			})
        );
    }
    
    public static saveCharge(formData: FormData) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/management/charges`, {
				headers: new Headers({ }),
				method: 'POST',
				body: formData,
				cache: 'no-cache'
			})
        );
    }
}
